let attachModeActive = false;

export function setAttachModeActive(active: boolean): void {
	attachModeActive = active;
}

export function isAttachModeActive(): boolean {
	return attachModeActive;
}
